/* cørt rankings — the opening view, the filters, the name search and the
   grassroots strand.

   The page opens on the world men's and women's tables, which are written into
   the HTML. The full directory (every ranked player) is fetched only when
   somebody searches or filters, so the page still costs nothing extra to open
   on a phone. Filters and the search box feed ONE result table: whatever is on
   screen always matches every control at once. */
(function () {
  var root = document.querySelector('.ck');
  if (!root) return;

  var chips = root.querySelectorAll('[data-chip]');
  var panels = root.querySelectorAll('[data-panel]');
  var chipNav = root.querySelector('.ck-chips');
  var panelWrap = root.querySelector('.ck-panels');
  var results = root.querySelector('[data-results]');
  var input = root.querySelector('#ck-q');
  var filterBox = root.querySelector('.ck-filter');
  var clearBtn = root.querySelector('[data-clear]');
  var selects = root.querySelectorAll('[data-f]');
  var dirUrl = root.getAttribute('data-dir');
  var dir = null, loading = false, timer = null, shown = 0, lastRows = [];

  /* ---- list tabs. "world" is the opening view: both world tables at once ---- */
  function showLists(keys) {
    panels.forEach(function (p) {
      var on = keys.indexOf(p.getAttribute('data-panel')) !== -1;
      p.classList.toggle('is-on', on);
      if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });
  }
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var key = chip.getAttribute('data-chip');
      chips.forEach(function (c) { c.classList.toggle('is-on', c === chip); });
      showLists(key === 'world' ? ['world-men', 'world-women'] : [key]);
    });
  });

  /* ---- the directory, loaded once, on demand ---- */
  function ensureDirectory(then) {
    if (dir) { then(); return; }
    if (loading) return;
    loading = true;
    results.hidden = false;
    results.innerHTML = '<p class="ck-res-note">Loading the full list…</p>';
    fetch(dirUrl, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) { dir = d; loading = false; then(); })
      .catch(function () {
        loading = false;
        results.innerHTML = '<p class="ck-res-note">The full list is not answering right now. The tables below still work.</p>';
      });
  }

  /* A list's tour, sex and age group travel in the directory. Older copies of
     the file do not carry them, so they are also read back off the list key —
     the page must not go blank because the directory is one publish behind. */
  function meta(list) {
    var k = list.k || '';
    var t = list.t || (/^world|^brits/.test(k) ? 'world' : 'britain');
    var s = list.s || (/women|female/.test(k) ? 'women' : 'men');
    var g = list.g || (/-40/.test(k) ? '40+' : /-50/.test(k) ? '50+' : /-60/.test(k) ? '60+' : 'open');
    return { t: t, s: s, g: g };
  }

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function clean(s) { return String(s == null ? '' : s).replace(/[<>&"]/g, ''); }

  /* ---- what the controls currently say ---- */
  function state() {
    var f = { tour: '', sex: '', grade: '', place: '', band: '' };
    selects.forEach(function (s) { f[s.getAttribute('data-f')] = s.value; });
    f.q = input ? input.value.trim() : '';
    return f;
  }
  function isFiltering(f) {
    return !!(f.tour || f.sex || f.grade || f.place || f.band || f.q.length >= 2);
  }

  /* The country/county dropdown only ever offers places that can return rows:
     countries when the world tour is chosen, counties when Britain is. */
  var places = {};
  try { places = JSON.parse(filterBox.getAttribute('data-places') || '{}'); } catch (e) { places = {}; }
  var placeSel = root.querySelector('[data-f="place"]');
  function syncPlaces(tour) {
    if (!placeSel) return;
    var keep = placeSel.value;
    var groups = placeSel.querySelectorAll('optgroup');
    groups.forEach(function (g) {
      var isWorld = /Countries/i.test(g.getAttribute('label') || '');
      var show = !tour || (tour === 'world' ? isWorld : !isWorld);
      g.hidden = !show;
      g.disabled = !show;
    });
    if (keep) {
      var still = (tour === 'world' ? places.world : tour === 'britain' ? places.britain : [])
        .concat(tour ? [] : (places.world || []).concat(places.britain || []));
      if (still.indexOf(keep) === -1) placeSel.value = '';
    }
  }

  /* ---- the one result table ---- */
  var PAGE = 100;

  function rowsFor(f) {
    var out = [];
    (dir.lists || []).forEach(function (list, idx) {
      var m = meta(list);
      if (f.tour && m.t !== f.tour) return;
      if (f.sex && m.s !== f.sex) return;
      if (f.grade && m.g !== f.grade) return;
      var needle = f.q.length >= 2 ? norm(f.q) : '';
      list.r.forEach(function (row) {
        if (f.place && row[2] !== f.place) return;
        if (f.band) {
          var parts = f.band.split('-');
          var lo = Number(parts[0] || 0), hi = parts[1] ? Number(parts[1]) : Infinity;
          if (row[0] < lo || row[0] > hi) return;
        }
        if (needle && norm(row[1]).indexOf(needle) === -1) return;
        out.push({ order: idx, list: list.l, rank: row[0], name: row[1], where: row[2], points: row[3] });
      });
    });
    out.sort(function (a, b) { return a.order - b.order || a.rank - b.rank; });
    return out;
  }

  function tableFor(rows, total) {
    return '<table class="ck-table ck-res-table"><thead><tr>' +
      '<th>#</th><th>Player</th><th>List</th><th>Country or county</th><th>Points</th>' +
      '</tr></thead><tbody>' + rows.map(function (h) {
        return '<tr><td class="ck-r">' + h.rank + '</td>' +
          '<td class="ck-n">' + clean(h.name) + '</td>' +
          '<td class="ck-l">' + clean(h.list) + '</td>' +
          '<td class="ck-c">' + clean(h.where) + '</td>' +
          '<td class="ck-p">' + Number(h.points).toLocaleString('en-GB') + '</td></tr>';
      }).join('') + '</tbody></table>' +
      (total > rows.length
        ? '<button type="button" class="ck-showmore" data-more>Show ' +
          Math.min(PAGE, total - rows.length) + ' more</button>'
        : '');
  }

  function describe(f, n) {
    var bits = [];
    if (f.tour) bits.push(f.tour === 'world' ? 'the world tour' : 'Britain');
    if (f.sex) bits.push(f.sex);
    if (f.grade && f.grade !== 'open') bits.push(f.grade);
    if (f.grade === 'open') bits.push('open');
    if (f.place) bits.push(f.place);
    if (f.band) bits.push(f.band === '501-' ? 'ranked 501 and below' : 'ranked ' + f.band.replace('-', ' to '));
    if (f.q.length >= 2) bits.push('matching “' + clean(f.q) + '”');
    return n.toLocaleString('en-GB') + (n === 1 ? ' player' : ' players') +
      (bits.length ? ', ' + bits.join(', ') : '');
  }

  function paint(f) {
    var rows = lastRows;
    var slice = rows.slice(0, shown);
    if (!rows.length) {
      results.innerHTML = '<p class="ck-res-note">No ranked player matches that. ' +
        'Ranking points come from LTA Padel Tour and FIP events, so a player with no tournament yet will not appear.</p>';
      return;
    }
    results.innerHTML = '<p class="ck-res-note">' + describe(f, rows.length) +
      (rows.length > slice.length ? '. Showing the first ' + slice.length : '') + '.</p>' +
      tableFor(slice, rows.length);
    var more = results.querySelector('[data-more]');
    if (more) {
      more.addEventListener('click', function () {
        shown += PAGE;
        paint(f);
      });
    }
  }

  function apply() {
    var f = state();
    if (!isFiltering(f)) {
      results.hidden = true;
      results.innerHTML = '';
      if (chipNav) chipNav.hidden = false;
      if (panelWrap) panelWrap.hidden = false;
      if (clearBtn) clearBtn.hidden = true;
      return;
    }
    if (clearBtn) clearBtn.hidden = false;
    ensureDirectory(function () {
      lastRows = rowsFor(f);
      shown = PAGE;
      results.hidden = false;
      if (chipNav) chipNav.hidden = true;
      if (panelWrap) panelWrap.hidden = true;
      paint(f);
    });
  }

  selects.forEach(function (s) {
    s.addEventListener('change', function () {
      if (s.getAttribute('data-f') === 'tour') syncPlaces(s.value);
      apply();
    });
  });
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      selects.forEach(function (s) { s.value = ''; });
      if (input) input.value = '';
      syncPlaces('');
      apply();
    });
  }
  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 180);
    });
  }

  /* ---- grassroots strand, off the same wire as the news page ---- */
  var grass = root.querySelector('[data-grass]');
  if (grass) {
    fetch('https://cort-news-live.pages.dev/feed.json', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (feed) {
        var items = (feed.items || []).filter(function (i) { return i.lane === 'uk'; });
        if (!items.length) items = (feed.items || []).slice(0, 6);
        items = items.slice(0, 6);
        if (!items.length) { grass.innerHTML = '<p class="ck-grass-wait">No club news on the wire right now.</p>'; return; }
        grass.innerHTML = items.map(function (i) {
          var when = i.published ? new Date(i.published).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) : '';
          return '<a class="ck-card" href="' + i.url + '" rel="noopener" target="_blank">' +
            '<span class="ck-card-src">' + clean(i.source) + '</span>' +
            '<span class="ck-card-h">' + clean(i.title) + '</span>' +
            '<span class="ck-card-when">' + when + '</span></a>';
        }).join('');
      })
      .catch(function () {
        grass.innerHTML = '<p class="ck-grass-wait">The wire is not answering right now.</p>';
      });
  }
})();
